export enum RenovationField {
  key = 'form-key',
  name_value = 'form-name_value',
  action = 'form-action-find',
  warehouse = 'warehouse_id',
}

export enum RenovationKeyField {
  prefix = 'k',
  positionValue = '1',
  barcode = 'k-x',
}

export const KeyConfig = {
  prefix: RenovationKeyField.prefix,
  positionValue: RenovationKeyField.positionValue,
};
